// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.streak-tracker {
  padding: 0;
  background: transparent;
  border-radius: 16px;
  transition: all 0.3s ease;
}

.streak-header {
  margin-bottom: 32px;
  text-align: center;
}

.streak-header h2 {
  font-size: 1.8rem;
  color: #2c3e50;
  margin-bottom: 16px;
  transition: color 0.3s ease;
  font-weight: 600;
}

.dark-mode .streak-header h2 {
  color: #f5f5f5;
}

.motivational-quote {
  font-style: italic;
  color: #7f8c8d;
  font-size: 1.1rem;
  line-height: 1.6;
  padding: 20px;
  background: white;
  border-radius: 16px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.05);
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.dark-mode .motivational-quote {
  background: #2d2d2d;
  color: #bbb;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 255, 255, 0.05);
}

.streak-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
}

.stat-card {
  background: white;
  padding: 24px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.dark-mode .stat-card {
  background: #2d2d2d;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 255, 255, 0.05);
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
}

.dark-mode .stat-card:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.stat-icon {
  font-size: 2.2rem;
  margin-right: 20px;
  background: rgba(0, 0, 0, 0.05);
  padding: 16px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dark-mode .stat-icon {
  background: rgba(255, 255, 255, 0.1);
}

.stat-icon.current {
  color: #e74c3c;
  background: rgba(231, 76, 60, 0.1);
}

.dark-mode .stat-icon.current {
  background: rgba(231, 76, 60, 0.15);
}

.stat-icon.best {
  color: #f1c40f;
  background: rgba(241, 196, 15, 0.1);
}

.dark-mode .stat-icon.best {
  background: rgba(241, 196, 15, 0.15);
}

.stat-info {
  flex: 1 1;
}

.stat-info h3 {
  font-size: 1rem;
  color: #7f8c8d;
  margin: 0 0 8px 0;
  font-weight: 500;
  transition: color 0.3s ease;
}

.dark-mode .stat-info h3 {
  color: #aaa;
}

.stat-value {
  font-size: 1.8rem;
  font-weight: 700;
  color: #2c3e50;
  transition: color 0.3s ease;
  line-height: 1.2;
}

.dark-mode .stat-value {
  color: #f5f5f5;
}

.stat-message {
  margin-left: auto;
  color: #27ae60;
  font-weight: 600;
  transition: color 0.3s ease;
}

.dark-mode .stat-message {
  color: #2ecc71;
}

.streak-calendar-section {
  margin-bottom: 32px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #2c3e50;
  margin-bottom: 16px;
  transition: color 0.3s ease;
  font-size: 1.25rem;
  font-weight: 600;
}

.section-title svg {
  color: #3498db;
}

.dark-mode .section-title {
  color: #f5f5f5;
}

.dark-mode .section-title svg {
  color: #4CA1D8;
}

.streak-calendar {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(50px, 1fr));
  gap: 8px;
  padding: 24px;
  background: white;
  border-radius: 16px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.dark-mode .streak-calendar {
  background: #2d2d2d;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 255, 255, 0.05);
}

.calendar-day {
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  border-radius: 10px;
  font-size: 0.9rem;
  color: #95a5a6;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
}

.dark-mode .calendar-day {
  background: #1e1e1e;
  color: #aaa;
}

.calendar-day:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
}

.dark-mode .calendar-day:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.calendar-day.active {
  background: #27ae60;
  color: white;
  box-shadow: 0 4px 8px rgba(39, 174, 96, 0.2);
}

.dark-mode .calendar-day.active {
  background: #2ecc71;
  box-shadow: 0 4px 8px rgba(46, 204, 113, 0.3);
}

.calendar-day.today {
  border: 2px solid #3498db;
  font-weight: 700;
}

.dark-mode .calendar-day.today {
  border-color: #4CA1D8;
}

.streak-insights {
  margin-bottom: 32px;
}

.insights-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
}

.insight-card {
  background: white;
  padding: 20px;
  border-radius: 16px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.dark-mode .insight-card {
  background: #2d2d2d;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 255, 255, 0.05);
}

.insight-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
}

.dark-mode .insight-card:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.insight-card h4 {
  color: #7f8c8d;
  font-size: 0.95rem;
  margin: 0 0 12px 0;
  font-weight: 500;
  transition: color 0.3s ease;
}

.dark-mode .insight-card h4 {
  color: #aaa;
}

.insight-value {
  font-size: 1.8rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 12px;
  transition: color 0.3s ease;
  line-height: 1.2;
}

.dark-mode .insight-value {
  color: #f5f5f5;
}

.insight-card p {
  color: #7f8c8d;
  font-size: 0.95rem;
  margin: 0;
  line-height: 1.5;
  transition: color 0.3s ease;
}

.dark-mode .insight-card p {
  color: #bbb;
}

.streak-motivation {
  background: white;
  padding: 24px;
  border-radius: 16px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.dark-mode .streak-motivation {
  background: #2d2d2d;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 255, 255, 0.05);
}

.streak-motivation h3 {
  color: #2c3e50;
  margin: 0 0 16px 0;
  font-size: 1.25rem;
  font-weight: 600;
  transition: color 0.3s ease;
}

.dark-mode .streak-motivation h3 {
  color: #f5f5f5;
}

.motivation-tips {
  display: grid;
  gap: 16px;
}

.tip {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 12px;
  color: #7f8c8d;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  line-height: 1.5;
  transition: all 0.3s ease;
}

.dark-mode .tip {
  background: #3d3d3d;
  color: #bbb;
}

.tip:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
}

.dark-mode .tip:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.tip svg {
  color: #3498db;
  margin-top: 2px;
  flex-shrink: 0;
}

.dark-mode .tip svg {
  color: #4CA1D8;
}

.tip strong {
  color: #2c3e50;
  font-weight: 600;
  display: block;
  margin-bottom: 4px;
}

.dark-mode .tip strong {
  color: #f5f5f5;
}

@media (max-width: 768px) {
  .streak-tracker {
    padding: 0;
  }
  
  .streak-stats {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .insights-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .stat-card {
    padding: 16px;
  }
  
  .stat-icon {
    font-size: 1.8rem;
    padding: 12px;
    margin-right: 16px;
  }
  
  .stat-value {
    font-size: 1.6rem;
  }
  
  .motivational-quote {
    padding: 16px;
    font-size: 1rem;
  }
  
  .stat-message {
    display: none;
  }
  
  .streak-calendar {
    grid-template-columns: repeat(auto-fill, minmax(40px, 1fr));
    padding: 16px;
  }
  
  .streak-motivation,
  .insight-card {
    padding: 16px;
  }
  
  .section-title {
    font-size: 1.15rem;
  }
}

@media (max-width: 480px) {
  .streak-header h2 {
    font-size: 1.6rem;
  }
  
  .calendar-day {
    font-size: 0.8rem;
  }
  
  .stat-icon {
    padding: 10px;
    margin-right: 12px;
    font-size: 1.5rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/StudyTools/StreakTracker.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,2DAA2D;IAC3D,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,iBAAiB;EACnB;AACF","sourcesContent":[".streak-tracker {\n  padding: 0;\n  background: transparent;\n  border-radius: 16px;\n  transition: all 0.3s ease;\n}\n\n.streak-header {\n  margin-bottom: 32px;\n  text-align: center;\n}\n\n.streak-header h2 {\n  font-size: 1.8rem;\n  color: #2c3e50;\n  margin-bottom: 16px;\n  transition: color 0.3s ease;\n  font-weight: 600;\n}\n\n.dark-mode .streak-header h2 {\n  color: #f5f5f5;\n}\n\n.motivational-quote {\n  font-style: italic;\n  color: #7f8c8d;\n  font-size: 1.1rem;\n  line-height: 1.6;\n  padding: 20px;\n  background: white;\n  border-radius: 16px;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  text-align: center;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.dark-mode .motivational-quote {\n  background: #2d2d2d;\n  color: #bbb;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border-color: rgba(255, 255, 255, 0.05);\n}\n\n.streak-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 24px;\n  margin-bottom: 32px;\n}\n\n.stat-card {\n  background: white;\n  padding: 24px;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.dark-mode .stat-card {\n  background: #2d2d2d;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border-color: rgba(255, 255, 255, 0.05);\n}\n\n.stat-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);\n}\n\n.dark-mode .stat-card:hover {\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n}\n\n.stat-icon {\n  font-size: 2.2rem;\n  margin-right: 20px;\n  background: rgba(0, 0, 0, 0.05);\n  padding: 16px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dark-mode .stat-icon {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.stat-icon.current {\n  color: #e74c3c;\n  background: rgba(231, 76, 60, 0.1);\n}\n\n.dark-mode .stat-icon.current {\n  background: rgba(231, 76, 60, 0.15);\n}\n\n.stat-icon.best {\n  color: #f1c40f;\n  background: rgba(241, 196, 15, 0.1);\n}\n\n.dark-mode .stat-icon.best {\n  background: rgba(241, 196, 15, 0.15);\n}\n\n.stat-info {\n  flex: 1;\n}\n\n.stat-info h3 {\n  font-size: 1rem;\n  color: #7f8c8d;\n  margin: 0 0 8px 0;\n  font-weight: 500;\n  transition: color 0.3s ease;\n}\n\n.dark-mode .stat-info h3 {\n  color: #aaa;\n}\n\n.stat-value {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: #2c3e50;\n  transition: color 0.3s ease;\n  line-height: 1.2;\n}\n\n.dark-mode .stat-value {\n  color: #f5f5f5;\n}\n\n.stat-message {\n  margin-left: auto;\n  color: #27ae60;\n  font-weight: 600;\n  transition: color 0.3s ease;\n}\n\n.dark-mode .stat-message {\n  color: #2ecc71;\n}\n\n.streak-calendar-section {\n  margin-bottom: 32px;\n}\n\n.section-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #2c3e50;\n  margin-bottom: 16px;\n  transition: color 0.3s ease;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.section-title svg {\n  color: #3498db;\n}\n\n.dark-mode .section-title {\n  color: #f5f5f5;\n}\n\n.dark-mode .section-title svg {\n  color: #4CA1D8;\n}\n\n.streak-calendar {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(50px, 1fr));\n  gap: 8px;\n  padding: 24px;\n  background: white;\n  border-radius: 16px;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.dark-mode .streak-calendar {\n  background: #2d2d2d;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border-color: rgba(255, 255, 255, 0.05);\n}\n\n.calendar-day {\n  aspect-ratio: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f8f9fa;\n  border-radius: 10px;\n  font-size: 0.9rem;\n  color: #95a5a6;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-weight: 500;\n}\n\n.dark-mode .calendar-day {\n  background: #1e1e1e;\n  color: #aaa;\n}\n\n.calendar-day:hover {\n  transform: scale(1.05);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);\n}\n\n.dark-mode .calendar-day:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.calendar-day.active {\n  background: #27ae60;\n  color: white;\n  box-shadow: 0 4px 8px rgba(39, 174, 96, 0.2);\n}\n\n.dark-mode .calendar-day.active {\n  background: #2ecc71;\n  box-shadow: 0 4px 8px rgba(46, 204, 113, 0.3);\n}\n\n.calendar-day.today {\n  border: 2px solid #3498db;\n  font-weight: 700;\n}\n\n.dark-mode .calendar-day.today {\n  border-color: #4CA1D8;\n}\n\n.streak-insights {\n  margin-bottom: 32px;\n}\n\n.insights-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 20px;\n}\n\n.insight-card {\n  background: white;\n  padding: 20px;\n  border-radius: 16px;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.dark-mode .insight-card {\n  background: #2d2d2d;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border-color: rgba(255, 255, 255, 0.05);\n}\n\n.insight-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);\n}\n\n.dark-mode .insight-card:hover {\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n}\n\n.insight-card h4 {\n  color: #7f8c8d;\n  font-size: 0.95rem;\n  margin: 0 0 12px 0;\n  font-weight: 500;\n  transition: color 0.3s ease;\n}\n\n.dark-mode .insight-card h4 {\n  color: #aaa;\n}\n\n.insight-value {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: #2c3e50;\n  margin-bottom: 12px;\n  transition: color 0.3s ease;\n  line-height: 1.2;\n}\n\n.dark-mode .insight-value {\n  color: #f5f5f5;\n}\n\n.insight-card p {\n  color: #7f8c8d;\n  font-size: 0.95rem;\n  margin: 0;\n  line-height: 1.5;\n  transition: color 0.3s ease;\n}\n\n.dark-mode .insight-card p {\n  color: #bbb;\n}\n\n.streak-motivation {\n  background: white;\n  padding: 24px;\n  border-radius: 16px;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.dark-mode .streak-motivation {\n  background: #2d2d2d;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border-color: rgba(255, 255, 255, 0.05);\n}\n\n.streak-motivation h3 {\n  color: #2c3e50;\n  margin: 0 0 16px 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  transition: color 0.3s ease;\n}\n\n.dark-mode .streak-motivation h3 {\n  color: #f5f5f5;\n}\n\n.motivation-tips {\n  display: grid;\n  gap: 16px;\n}\n\n.tip {\n  background: #f8f9fa;\n  padding: 16px;\n  border-radius: 12px;\n  color: #7f8c8d;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  line-height: 1.5;\n  transition: all 0.3s ease;\n}\n\n.dark-mode .tip {\n  background: #3d3d3d;\n  color: #bbb;\n}\n\n.tip:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);\n}\n\n.dark-mode .tip:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.tip svg {\n  color: #3498db;\n  margin-top: 2px;\n  flex-shrink: 0;\n}\n\n.dark-mode .tip svg {\n  color: #4CA1D8;\n}\n\n.tip strong {\n  color: #2c3e50;\n  font-weight: 600;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.dark-mode .tip strong {\n  color: #f5f5f5;\n}\n\n@media (max-width: 768px) {\n  .streak-tracker {\n    padding: 0;\n  }\n  \n  .streak-stats {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  \n  .insights-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  \n  .stat-card {\n    padding: 16px;\n  }\n  \n  .stat-icon {\n    font-size: 1.8rem;\n    padding: 12px;\n    margin-right: 16px;\n  }\n  \n  .stat-value {\n    font-size: 1.6rem;\n  }\n  \n  .motivational-quote {\n    padding: 16px;\n    font-size: 1rem;\n  }\n  \n  .stat-message {\n    display: none;\n  }\n  \n  .streak-calendar {\n    grid-template-columns: repeat(auto-fill, minmax(40px, 1fr));\n    padding: 16px;\n  }\n  \n  .streak-motivation,\n  .insight-card {\n    padding: 16px;\n  }\n  \n  .section-title {\n    font-size: 1.15rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .streak-header h2 {\n    font-size: 1.6rem;\n  }\n  \n  .calendar-day {\n    font-size: 0.8rem;\n  }\n  \n  .stat-icon {\n    padding: 10px;\n    margin-right: 12px;\n    font-size: 1.5rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
